import { render, staticRenderFns } from "./Zuowei.vue?vue&type=template&id=3c7ca7a8&scoped=true"
import script from "./Zuowei.vue?vue&type=script&lang=js"
export * from "./Zuowei.vue?vue&type=script&lang=js"
import style0 from "./Zuowei.vue?vue&type=style&index=0&id=3c7ca7a8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7ca7a8",
  null
  
)

export default component.exports